import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {RestDataSource} from '../../shared/rest-data-source';
import {MatSort} from '@angular/material/sort';
import {PaginatorComponent} from '../../shared/paginator';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {AdminApi} from '../admin-api';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Toast} from '../../shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';

@Component({
   selector: 'app-pdf-template-list-dialog',
   templateUrl: './pdf-template-list-dialog.component.html',
   styleUrls: ['./pdf-template-list-dialog.component.css'],
})
export class PdfTemplateListDialogComponent implements OnInit {
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild('wrapper') container: ElementRef;
   @ViewChild(AppLoaderComponent, {static: true}) loader: AppLoaderComponent;
   @ViewChild('search', {static: true}) search: ElementRef;

   private timer: any;
   dataSource = new RestDataSource<any>();
   formType: string;
   selectedRowIndex: number;
   displayedColumns = ['templateName', 'createdBy', 'updateDate', 'versions'];
   filterValue = '';
   orderBy = '';
   orderType = '';
   sortOrder = 'formName';
   sortDirect = 'asc';
   searchFocused: boolean;
   index: any;
   size: any;
   searchResult: any[];
   preventBlur: boolean;
   searchvalue: any;
   searching: any;
   draft: any;
   publish: any;
   allData: any[] = [];
   isLoadingResults = false;
   formList = [];
   isSelectAll = false;
   disabledBtn = true;
   data: any;
   path: string;
   fromPage: string;

   constructor(@Inject(MAT_DIALOG_DATA) private injectData: any,
               private api: AdminApi,
               private route: ActivatedRoute,
               private dialog: MatDialog,
               private toast: Toast,
               private translate: TranslateService, 
               private router: Router) {
   }

   ngOnInit(): void {
      localStorage.setItem('callback-url', this.router.url);
      localStorage.setItem('form-type', 'dms');
      localStorage.setItem('template-path', this.path);
      this.getListPdfTemplate('');
   }

   onClickPdfTemplate(docId: string) {
      const info = {
         tin: localStorage.getItem('siteCode'),
         destination: localStorage.getItem('template-path')
      };
      if (this.fromPage === 'addTemplate') {
         this.api.getPdfTemplate(docId)
            .subscribe(data => {
               this.injectData.pdfTemplateListDialog.close(data);
            }, e => {
               this.handleErrors(e);
               this.loader.hide();
            });
      } else {
         this.api.createPdfTemplate(docId, info)
            .subscribe(data => {
               this.injectData.pdfTemplateListDialog.close();
               sessionStorage.setItem('isShowStartFlow', 'true');
               this.router.navigate(['/file/' + data.docId]);
            }, e => {
               this.handleErrors(e);
               this.loader.hide();
            });
      }
   }

   getListPdfTemplate(type) {
      this.loader.show();
      this.selectedRowIndex = -1;
      this.isLoadingResults = true;
      this.dataSource = new RestDataSource<any>();
      this.dataSource.paginator = this.paginator;
      this.index = this.paginator.page;
      this.size = this.paginator.size;
      localStorage.setItem('page_index', this.index);

      if (this.size === undefined) {
        this.size = 50;
      }

      if (this.sort) {
        this.dataSource.sort = this.sort;
      }

      this.sortOrder = localStorage.getItem('sortOrderDialog') || 'updateDate';
      this.sortDirect = localStorage.getItem('sortDirect') || 'desc';

      if (type === 'sort' && this.sort) {
        this.sortOrder = this.sort.active;
        this.sortDirect = this.sort.direction;
        localStorage.setItem('sortOrderDialog', this.sortOrder);
        localStorage.setItem('sortDirect', this.sortDirect);
      }
      this.api.listPdfTemplateOnlyActive(localStorage.getItem('tin'), encodeURIComponent(this.filterValue.trim()), this.sortOrder, this.sortDirect, this.index, this.size, null)
        .subscribe(data => {
            data.content = data.content.filter(item => item.isActive && item.publishBy);

            this.data = data;
            for (const list of data.content) {
              list.createdDate = new Date(list.createdDate.replace(/-/g, '/'));
              list.updateDate = new Date(list.updateDate.replace(/-/g, '/'));
            }

            this.dataSource.loaded(data);
            this.allData = data.content;
            this.isLoadingResults = false;
            if (this.allData.length === 0) {
              this.isLoadingResults = true;
            }
            this.container.nativeElement.scrollTop = 0;
            this.loader.hide();
        }, e => {
          this.handleErrors(e);
          this.loader.hide();
        });
    }

   // Wait for Specification Error Message
   handleErrors(e: any) {
      if (e.status === 404) {
         this.toast.error('Service Not Found.');
      }
   }

   clearData() {
      this.paginator.firstPage();
      this.filterValue = '';
      this.search.nativeElement.value = '';
      this.disabledBtn = true;
      this.formList = [];
      this.isSelectAll = false;
   }

   onSearch(value: any) {
      this.searchFocused = false;
      this.searchvalue = value;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = encodeURIComponent(value.trim());
      if (q.length === 0) {
         value = '';
      } else {
         value = value.trim(); // Remove whitespace
         value = value.toLowerCase();
      }
      this.filterValue = value;
      this.getListPdfTemplate('');
   }

   onSearchChange(input: any, e: any) {
      localStorage.setItem('searchValue', input.value);
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      this.filterValue = encodeURIComponent(input.value.trim());
      if (this.filterValue.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.api.listPdfTemplateOnlyActive(localStorage.getItem('tin'), this.filterValue, this.orderBy,
            this.orderType, 0, 8, null)
            .subscribe(
               data => {
                  data.content = data.content.filter(item => item.isActive && item.publishBy );
                  if (this.timer == null) {
                     this.searchResult = data.content;
                  }
               });
      }, 300);
   }

   checkFormList(formList) {
      if (formList.length === 0) {
         return false;
      } else {
         return true;
      }
   }
}
